import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayOPEEnum} from "./GatewayOPEEnum";

/**
 * O Inner Class
 */
class O {
  password?: string;
}

/**
 * I Inner Class
 */
class I {
  id!: number;
}

export class GetNetInterfacePasswordCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayOPEEnum.GetNetInterfacePassword);
    this.i = new I();
    this.o = new O();
  }
}
